import { AxiosAdapter } from '../../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getProducts(productsId) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/product/${Enviroment.COUNTRY}/find-by-multiple-ids/${productsId}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async updateProducts(products, id) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.MIGRATION_PHAROL}/carousel-product/only-products/${id}`,
			data: products,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
